import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import Message from "../message";

function Startupindia() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [DPIIT, setDPIIT] = useState(false);
  const [IAC, setIAC] = useState(false);
  const [scaling, setScaling] = useState(false);
  const [ideation, setIdeation] = useState(false);
  const [validation, setValidation] = useState(false);
  const [early_traction, setEarly_traction] = useState(false);

  const [status_startupindia, setStatus_startupindia] = useState("");

  const submit_startupindia = async () => {
    console.log("DPIIT", DPIIT);
    console.log("IAC", IAC);
    console.log("scaling", scaling);
    console.log("ideation", ideation);
    console.log("validation", validation);
    console.log("early_traction", early_traction);

    var dpiitRecogniseUser = "false";
    var is80iacExempted = "false";
    var stages = [];

    if (DPIIT === true) {
      dpiitRecogniseUser = "true";
    }
    if (IAC === true) {
      is80iacExempted = "true";
    }
    if (scaling === true) {
      stages.push("Scaling");
    }
    if (ideation === true) {
      stages.push("Prototype");
    }
    if (validation === true) {
      stages.push("Validation");
    }
    if (early_traction === true) {
      stages.push("EarlyTraction");
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dpiitRecogniseUser: dpiitRecogniseUser,
        is80iacExempted: is80iacExempted,
        stages: stages,
      }),
    };

    try {
      const startupindia_response = await fetch(
        apiServer + "api/startupindia/get_data",
        requestOptions
      );
      const startupindia_status_id = await startupindia_response.json();
      const startupindia_status = startupindia_status_id.detail
        ? startupindia_status_id.detail
        : startupindia_status_id;
      setStatus_startupindia(startupindia_status);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div style={{ width: "100%", height: "100%", marginTop: "10px" }}>
      <Form.Check
        onChange={(e) => setDPIIT(e.target.checked)}
        type="checkbox"
        label="DPIIT Recognised Startup"
      />
      <Form.Check
        onChange={(e) => setIAC(e.target.checked)}
        type="checkbox"
        label="80IAC Exempted Startups"
      />
      <Row>
        <Col>
          <Form.Check
            onChange={(e) => setScaling(e.target.checked)}
            type="checkbox"
            label="Scaling"
          />
          <Form.Check
            onChange={(e) => setIdeation(e.target.checked)}
            type="checkbox"
            label="Ideation"
          />
        </Col>
        <Col>
          <Form.Check
            onChange={(e) => setValidation(e.target.checked)}
            type="checkbox"
            label="Validation"
          />
          <Form.Check
            onChange={(e) => setEarly_traction(e.target.checked)}
            type="checkbox"
            label="Early Traction"
          />
        </Col>

        {/*<Col>*/}
        {/*    <div>STAGE:</div>*/}
        {/*    <Form.Check style={{marginTop: "5px"}} onChange={e => setScaling(e.target.checked)} type="checkbox" label="Scaling" />*/}
        {/*    <Form.Check style={{marginTop: "5px"}} onChange={e => setIdeation(e.target.checked)} type="checkbox" label="Ideation" />*/}
        {/*    <Form.Check style={{marginTop: "5px"}} onChange={e => setValidation(e.target.checked)} type="checkbox" label="Validation" />*/}
        {/*    <Form.Check style={{marginTop: "5px"}} onChange={e => setEarly_traction(e.target.checked)} type="checkbox" label="Early Traction" />*/}
        {/*</Col>*/}
      </Row>

      <Button
        variant="primary"
        style={{ marginTop: "10px", width: "100%" }}
        onClick={() => submit_startupindia()}
      >
        Submit
      </Button>
      {Message(status_startupindia, setStatus_startupindia)}
    </div>
  );
}

export default Startupindia;
